import { Collapse } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Bot, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CapabilitiesContainer,
  CapabilitiesContent,
  CapabilitiesHeader,
  CapabilitiesIconBox,
  CapabilitiesList,
  CapabilitiesListItem,
  CapabilitiesText,
  CapabilitiesToggle
} from "./AISupportChatCapabilities.styles";

const CAPABILITIES_ITEMS = [1, 2, 3, 4, 5, 6];

const AISupportChatCapabilities = () => {

  const { t } = useTranslation();
  const theme = useTheme();

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <CapabilitiesContainer
      id="agent-capabilities"
      data-testid="agent-capabilities"
    >
      <CapabilitiesHeader>
        <CapabilitiesIconBox>
          <Bot
            aria-hidden={ true }
            color={ theme.customColors.textPrimaryCta }
            size={ 24 }
          />
        </CapabilitiesIconBox>
        <CapabilitiesToggle
          type="button"
          id="agent-capabilities-toggle"
          aria-expanded={ isExpanded }
          aria-controls="agent-capabilities-content"
          onClick={ () => setIsExpanded((prev) => !prev) }
        >
          { isExpanded
            ? t("ai_support_capabilities_hide")
            : t("ai_support_capabilities_show") }
          { isExpanded ? (
            <ChevronUp size={ "1rem" } />
          ) : (
            <ChevronDown size={ "1rem" } />
          ) }
        </CapabilitiesToggle>
      </CapabilitiesHeader>
      <Collapse in={ isExpanded } timeout="auto" unmountOnExit>
        <CapabilitiesContent id="agent-capabilities-content">
          <CapabilitiesText>
            { t("ai_support_capabilities_intro") }
          </CapabilitiesText>
          <CapabilitiesList>
            { CAPABILITIES_ITEMS.map((item) => (
              <CapabilitiesListItem key={ `ai_support_capabilities_item_${item}` }>
                { t(`ai_support_capabilities_item_${item}`) }
              </CapabilitiesListItem>
            )) }
          </CapabilitiesList>
        </CapabilitiesContent>
      </Collapse>
    </CapabilitiesContainer>
  );
};

export default AISupportChatCapabilities;
